import {
  getTrackingByGa4Id
} from "./chunk-BN3UX2DC.js";
import {
  getTrackingByShopId
} from "./chunk-567DNN2M.js";
import {
  listingLead
} from "./chunk-P2JWEVJL.js";
import {
  messageChatbot
} from "./chunk-M72FWNBV.js";
import {
  searchListings
} from "./chunk-HJ2VW26B.js";
import {
  searchListingsCoordinates
} from "./chunk-KMVVKEZK.js";
import {
  deleteSearchAlertPublic,
  getSearchAlertForDisplay
} from "./chunk-LGU4MZFU.js";
import {
  getLocationDetails
} from "./chunk-XPLQ7VDC.js";
import {
  getPropertyEnginePlaceDetails
} from "./chunk-TTEQJIV7.js";
import {
  getShopById
} from "./chunk-QHEUKYAE.js";
import {
  getShopsByIds
} from "./chunk-MQT67F7G.js";
import {
  getSimilarListings
} from "./chunk-2YNTNOXB.js";
import {
  getSuggestions
} from "./chunk-CCCQ7P4Z.js";
import {
  getPlaceSuggestions
} from "./chunk-T334FGP3.js";
import {
  getSuggestionsByDisplayId
} from "./chunk-R4Y3QH3V.js";
import {
  deleteSearchAlert
} from "./chunk-ISQI7WHL.js";
import {
  getAISearchEnabledOutCountries
} from "./chunk-EEK2YGVR.js";
import {
  getAgentById
} from "./chunk-Q23PUYP7.js";
import {
  getFavorites
} from "./chunk-LPP34XZT.js";
import {
  getFilterByAiPrompt
} from "./chunk-5SXSIVKI.js";
import {
  getFuzzyPoint,
  publicForwardGeocoding,
  publicReverseGeocoding
} from "./chunk-MJWYYICO.js";
import {
  getListingById
} from "./chunk-62Q4D7SW.js";
import {
  createSearchAlert
} from "./chunk-4TYUPYJV.js";
import {
  createWhatsappLead
} from "./chunk-G7CR5AW5.js";
import {
  addCustomPlace,
  addCustomPlaceBlacklistEntry,
  addCustomPlaceEv,
  deleteCustomPlace,
  deleteCustomPlaceBlacklistEntry,
  getCustomPlaces
} from "./chunk-HKR3YXDM.js";
import {
  deleteAllFavorites
} from "./chunk-MKYVQPAC.js";
import {
  deleteAllSearchAlerts
} from "./chunk-MWG32X6D.js";
import {
  editSearchAlert
} from "./chunk-DWIVOL4D.js";
import {
  findAllSearchAlerts
} from "./chunk-DMPIIZL2.js";
import {
  deleteFavoriteByListingId
} from "./chunk-OEEORMJ2.js";
import {
  createFavorites
} from "./chunk-5PZYIEOH.js";
import {
  getConfigWithMetadata,
  mergeApiConfig,
  mergeHeaders
} from "./chunk-NFLWKIRZ.js";
import {
  getErrorResult
} from "./chunk-IPNO7PON.js";

// src/services/publicReverseGeocoding/publicReverseGeocoding.ts
async function publicReverseGeocoding2(params, apiConfig) {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, "publicReverseGeocoding");
    const data = await publicReverseGeocoding(params, _apiConfig);
    return {
      status: "success",
      data
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}

// src/services/publicForwardGeocoding/publicForwardGeocoding.ts
async function publicForwardGeocoding2(params, apiConfig) {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, "publicForwardGeocoding");
    const data = await publicForwardGeocoding(params, _apiConfig);
    return {
      status: "success",
      data
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}

// src/client.ts
var SearchApi = class _SearchApi {
  config;
  constructor(config) {
    this.config = { ...config, environment: config.environment || "prod" };
  }
  /**
   * Create a copy of the current instance with config overrides.
   */
  withConfig = (config) => new _SearchApi(mergeApiConfig(this.config, config));
  /**
   * Create a copy of the current instance with the provided headers.
   */
  withHeaders = (headers) => this.withConfig({
    headers: mergeHeaders(this.config.headers, headers)
  });
  /**
   * Fetch property listings based on provided filters and options using the `/api/v2/listing/search` endpoint.
   *
   * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/listings/searchListings Search API Documentation}
   */
  searchListings = (filters, options) => searchListings(filters, options, this.config);
  /**
   * Fetch properties coordinates based on provided filters using the `/api/v2/listing/search/geopoints` endpoint.
   *
   * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/listings/searchListingsCoordinates Search API Documentation}
   */
  searchListingsCoordinates = (...params) => searchListingsCoordinates(...params, this.config);
  /**
   * Fetch location suggestions based on the provided query and options using the `/api/v2/autosuggestion/suggest` endpoint.
   *
   * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/autosuggestion/getPlaceSuggestions Search API Documentation}
   */
  getPlaceSuggestions = (...params) => getPlaceSuggestions(...params, this.config);
  /**
   * Fetch detailed property information by its listing ID (UUID) using the `/api/v2/listing/{listingId}` endpoint.
   *
   * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/listings/getListingById Search API Documentation}
   */
  getListingById = (...params) => getListingById(...params, this.config);
  /**
   * Fetch property listings that are similar to a given listing using the `/api/v1/listing/search/minified` endpoint.
   *
   * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/listings/getSimilarListings Search API Documentation}
   */
  getSimilarListings = (...params) => getSimilarListings(...params, this.config);
  /**
   * Fetch either property listing suggestions or place suggestions based on the provided query using either the `/api/v2/autosuggestion/listing/suggest` or `/api/v2/autosuggestion/suggest` endpoint.
   *
   * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/autosuggestion/getSuggestions Search API Documentation}
   */
  getSuggestions = (...params) => getSuggestions(...params, this.config);
  /**
   * Fetch suggestions based on a partial or full display ID using the `/api/v2/autosuggestion/listing/suggest` endpoint.
   *
   * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/autosuggestion/getSuggestionsByDisplayId Search API Documentation}
   */
  getSuggestionsByDisplayId = (...params) => getSuggestionsByDisplayId(...params, this.config);
  /**
   * Fetch detailed location information for a given place ID using the `/api/v2/autosuggestion/details` endpoint.
   *
   * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/autosuggestion/getLocationDetails Search API Documentation}
   */
  getLocationDetails = (...params) => getLocationDetails(...params, this.config);
  /**
   * Fetch detailed location information for a given place ID using the `/api/v1/autosuggestion/property-engine/details` endpoint.
   *
   * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/autosuggestion/getPropertyEnginePlaceDetails Search API Documentation}
   */
  getPropertyEnginePlaceDetails = (...params) => getPropertyEnginePlaceDetails(...params, this.config);
  /**
   * Fetch custom places using the `/api/v1/autosuggestion/data/custom-places` endpoint.
   */
  getCustomPlaces = (...params) => getCustomPlaces(...params, this.config);
  /**
   * Create a Google custom place using the `/api/v1/autosuggestion/data/custom-places/google` endpoint.
   */
  addCustomPlace = (...params) => addCustomPlace(...params, this.config);
  /**
   * Create an EV custom place using the `/api/v1/autosuggestion/data/custom-places/ev` endpoint.
   */
  addCustomPlaceEv = (...params) => addCustomPlaceEv(...params, this.config);
  /**
   * Create a custom place blacklist entry using the `/api/v1/autosuggestion/data/custom-places/blacklist` endpoint.
   */
  addCustomPlaceBlacklistEntry = (...params) => addCustomPlaceBlacklistEntry(...params, this.config);
  /**
   * Delete a custom place using the `/api/v1/autosuggestion/data/custom-places/{placeId}` endpoint.
   */
  deleteCustomPlace = (...params) => deleteCustomPlace(...params, this.config);
  /**
   * Delete a custom place blacklist entry using the `/api/v1/autosuggestion/data/custom-places/blacklist/{placeId}` endpoint.
   */
  deleteCustomPlaceBlacklistEntry = (...params) => deleteCustomPlaceBlacklistEntry(...params, this.config);
  /**
   * Create a search alert using the `/api/v4/searchalert/alert` endpoint.
   *
   * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/searchAlerts/createSearchAlert Search API Documentation}
   */
  createSearchAlert = (...params) => createSearchAlert(...params, this.config);
  /**
   * Delete all search alerts of an Account using the `/api/v4/searchalert/alert` endpoint.
   *
   * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/searchAlerts/deleteAllSearchAlert Search API Documentation}
   */
  deleteAllSearchAlerts = (...params) => deleteAllSearchAlerts(...params, this.config);
  /**
   * Delete a search alert using the `/api/v4/searchalert/alert/{searchAlertId}` endpoint.
   *
   * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/searchAlerts/deleteSearchAlert Search API Documentation}
   */
  deleteSearchAlert = async (...params) => deleteSearchAlert(...params, this.config);
  /**
   * Edit a search alert using the `/api/v4/searchalert/alert/{searchAlertId}` endpoint.
   *
   * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/searchAlerts/editSearchAlert Search API Documentation}
   */
  editSearchAlert = (...params) => editSearchAlert(...params, this.config);
  /**
   * Find all search alerts of an account using the `/api/v4/searchalert/alert` endpoint.
   *
   * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/searchAlerts/findAllSearchAlerts Search API Documentation}
   */
  findAllSearchAlerts = (...params) => findAllSearchAlerts(...params, this.config);
  /**
   * Returns all tracking ids based on a given google GA4 id using the `/api/v2/tracking/ga4/{ga4Id}` endpoint.
   *
   * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/tracking/getTrackingByGa4Id Search API Documentation}
   */
  getTrackingByGa4Id = (...params) => getTrackingByGa4Id(...params, this.config);
  /**
   * Returns all tracking ids based on a given master data shop id using the `/api/v2/tracking/shop/{masterDataShopId}` endpoint.
   *
   * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/tracking/getTrackingByShopId Search API Documentation}
   */
  getTrackingByShopId = (...params) => getTrackingByShopId(...params, this.config);
  /**
   * Lead contact form to request further information, viewing, callback, etc. for a certain listing using the `/api/v3/listing/{listingID}/lead` endpoint.
   *
   * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/leads/listingLead Search API Documentation}
   */
  listingLead = (...params) => listingLead(...params, this.config);
  /**
   * Creates a WhatsApp lead and returns the wa.me redirect URL using the `/api/v1/listing/{listingId}/lead/whatsapp` endpoint.
   */
  createWhatsappLead = (...params) => createWhatsappLead(...params, this.config);
  /**
   * Fetch fuzzy point information based on the original point provided using the `/api/v1/geocode/fuzzy/point` endpoint.
   *
   * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/geocoding/getFuzzyPoint Search API Documentation}
   */
  getFuzzyPoint = (...params) => getFuzzyPoint(...params, this.config);
  /**
   * Fetch favorites for an account using the `/api/v1/favorites/account/{accountId}/listings` endpoint.
   *
   * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/favorites/getFavorites Search API Documentation}
   */
  getFavorites = (...params) => getFavorites(...params, this.config);
  /**
   * Create favorites for a given account using the `/api/v1/favorites/account/{accountId}/listings` endpoint.
   *
   * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/favorites/createFavorites Search API Documentation}
   */
  createFavorites = (...params) => createFavorites(...params, this.config);
  /**
   * Delete all favorites for an account using the `/api/v1/favorites/account/{accountId}/listings` endpoint.
   *
   * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/favorites/deleteAllFavorites Search API Documentation}
   */
  deleteAllFavorites = (...params) => deleteAllFavorites(...params, this.config);
  /**
   * Delete a property from the Favorites list for an account using the `/api/v1/favorites/account/{accountId}/listing/{listingId}` endpoint.
   *
   * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/favorites/deleteFavoriteByListingId Search API Documentation}
   */
  deleteFavoriteByListingId = (...params) => deleteFavoriteByListingId(...params, this.config);
  /**
   * Fetch public forward geocoding using the `/api/v2/public/geocode/forward` endpoint.
   *
   * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/geocoding/publicForwardGeocoding Search API Documentation}
   */
  publicForwardGeocoding = (...params) => publicForwardGeocoding2(...params, this.config);
  /**
   * Fetch public reverse geocoding using the `/api/v2/public/geocode/reverse` endpoint.
   *
   * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/geocoding/publicReverseGeocoding Search API Documentation}
   */
  publicReverseGeocoding = (...params) => publicReverseGeocoding2(...params, this.config);
  /**
   * Fetch the agent details based on a given agent id using the `/api/v1/masterdata/agent/{agentId}` endpoint.
   *
   * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/agent/getAgentById Search API Documentation}
   */
  getAgentById = (...params) => getAgentById(...params, this.config);
  /**
   * Fetch shop details by master data id or short id using the `/api/v1/masterdata/shop/{idOrShortId}` endpoint.
   *
   * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/shop/getShopById Search API Documentation}
   */
  getShopById = (...params) => getShopById(...params, this.config);
  /**
   * Fetch shop details for multiple master data ids or short ids using the `/api/v1/masterdata/shop` endpoint.
   *
   * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/shop/getShopsByIds Search API Documentation}
   */
  getShopsByIds = (...params) => getShopsByIds(...params, this.config);
  /**
   * Get search alert information and optionally prolong it (public endpoint)
   * using the `/api/v4/public/searchalert/alert/{searchAlertId}` endpoint.
   *
   * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/searchAlerts/getSearchAlertForDisplay Search API Documentation}
   */
  getSearchAlertForDisplay = (...params) => getSearchAlertForDisplay(...params, this.config);
  /**
   * Delete a search alert (public endpoint) using the `/api/v4/searchalert/unauth/alert/{searchAlertId}` endpoint.
   *
   * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/searchAlerts/deleteSearchAlertPublic Search API Documentation}
   */
  deleteSearchAlertPublic = (...params) => deleteSearchAlertPublic(...params, this.config);
  /**
   * Fetches the countries for which the BFF already supports AI search using the `/api/v1/ai/rolled-out-countries` endpoint.
   *
   * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/ai/getAISearchEnabledOutCountries Search API Documentation}
   */
  getAISearchEnabledOutCountries = (...params) => getAISearchEnabledOutCountries(...params, this.config);
  /**
   * Converts a text to a search filter using the `/api/v1/ai/text-to-filter` endpoint.
   *
   * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/ai/getFilterByAiPrompt Search API Documentation}
   */
  getFilterByAiPrompt = (...params) => getFilterByAiPrompt(...params, this.config);
  /**
   * Send a message to the chatbot using the `/api/v1/ai-chatbot/message` endpoint.
   *
   * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/chatbot/messageChatbot Search API Documentation}
   */
  messageChatbot = (...params) => messageChatbot(...params, this.config);
};

export {
  SearchApi
};
